export const GATE_LEDGER_SILENT_REASON_CODES = Object.freeze([
  'component_builder_null',
  'lever_unsized_dropped',
  'deck_lever_evidence_empty',
  'aggregate_posture_suppressed',
  'route_no_match',
  'route_hint_not_seeded',
  'proof_citation_unbound',
  'proof_bare_number',
  'proof_placeholder_invalid',
  'fold_value_unpriced',
  'fold_anchor_key_unbound',
  // #4008 — more than one intent claimed a lever's contribution contract (or
  // none did), so the source selector refused to choose and the lever was
  // skipped. This is the silent drop that removed `risk_claims` from the
  // certified floor and rendered the committable amount ABSENT.
  'value_gap_bridge_lever_source_intent_unresolved',
  'workspace_evidence_posture_failed',
] as const);

export type GateLedgerSilentReasonCode =
  (typeof GATE_LEDGER_SILENT_REASON_CODES)[number];
